import type { SVGProps } from 'react';
export type IconName =
  | 'check'
  | 'info'
  | 'warning'
  | 'error'
  | 'calendar'
  | 'currency'
  | 'spacing'
  | 'type'
  | 'menu'
  | 'chevron'
  | 'home'
  | 'palette'
  | 'layout'
  | 'loading'
  | 'empty'
  | 'lock'
  | 'edit'
  | 'camera'
  | 'offline';
const paths: Record<IconName, string> = {
  check: 'M5 12.5 9.2 17 19 7',
  info: 'M12 11v6m0-10v.01',
  warning: 'M12 4 3 20h18L12 4Zm0 6v4m0 3v.01',
  error: 'M7 7l10 10M17 7 7 17',
  calendar: 'M5 5h14v14H5V5Zm3-2v4m8-4v4M5 9h14',
  currency: 'M16 8c0-2-1.8-3-4-3S8 6 8 8s1.7 3 4 3 4 1 4 3-1.8 3-4 3-4-1-4-3m4-12v18',
  spacing: 'M4 7h16M4 17h16M8 4v6m8 4v6',
  type: 'M5 6V4h14v2m-7-2v16m-4 0h8',
  menu: 'M4 7h16M4 12h16M4 17h16',
  chevron: 'm8 10 4 4 4-4',
  home: 'm4 11 8-7 8 7v9h-6v-6h-4v6H4v-9Z',
  palette:
    'M12 4a8 8 0 1 0 0 16h1.2a1.8 1.8 0 0 0 0-3.6h-.8a1.5 1.5 0 0 1 0-3h3.1A4.5 4.5 0 0 0 20 8.9C18.5 5.9 15.6 4 12 4Z',
  layout: 'M4 4h16v16H4V4Zm5 0v16m0-10h11',
  loading: 'M12 3a9 9 0 1 0 9 9',
  empty: 'M4 7h16v12H4V7Zm4-3h8l2 3M4 13h4l2 2h4l2-2h4',
  lock: 'M6 10h12v10H6V10Zm3 0V7a3 3 0 0 1 6 0v3m-3 4v2',
  edit: 'M4 20h4l11-11-4-4L4 16v4Zm9.5-13.5 4 4M12 20h8',
  camera: 'M4 8h3l1.5-2h7L17 8h3v11H4V8Zm8 2.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z',
  offline:
    'M3 3l18 18M8.5 8.5A9 9 0 0 1 21 10m-4 4a7 7 0 0 0-3.5-1.9M3 10a9 9 0 0 1 2.4-1.6M8 15a6 6 0 0 1 2.2-1.3M12 19v.01',
};
export function Icon({
  name,
  title,
  ...props
}: SVGProps<SVGSVGElement> & { name: IconName; title?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
      {...props}
    >
      {title ? <title>{title}</title> : null}
      <path d={paths[name]} />
    </svg>
  );
}
